import apiClient from '../apiClient';
import { PUT_TRANSPORTATION_UNIT_HEADER_URL } from '../apiUrl';

const putTransporationUnitHeaderApi = (Id, data) => {
  return apiClient.put(PUT_TRANSPORTATION_UNIT_HEADER_URL(Id), data);
};

export default putTransporationUnitHeaderApi;
